export const STATUS_DELIVERED = 100
export const STATUS_IN_PROGRESS = 50
export const STATUSES = [STATUS_IN_PROGRESS, STATUS_DELIVERED]